/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-09-06 16:44:37
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-06-14 17:40:08
 * @FilePath: /zcy-claim-front/src/layouts/ZcyLayout.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Redirect, Route, Switch } from 'dva/router';
import React from 'react';
import Authorized from 'src/components/Authorized';
import NotFound from 'src/routes/Exception/views/404';
import us_aplus_queue from '../utils/baseAplus';
import { getRoutes } from '../utils/utils';

const { AuthorizedRoute } = Authorized;

export class ZcyBaseLayout extends React.Component {
  componentDidMount() {
    // 页面加载后，隐藏loading
    document.getElementById('zlb-hbs-loading').style.zIndex = '-1';
    document.onkeydown = e => {
      let keyCode = e.keyCode || e.which || e.charCode;
      let ctrlKey = e.ctrlKey;
      // ctrl+i
      if (ctrlKey && keyCode === 71) {
        console.log('组合i');
      }
    };
  }

  render() {
    const { routerData, match } = this.props;
    // 若处在用户行为路径埋点中，不记录行为场景埋点
    const storageSpmObj = JSON.parse(sessionStorage.getItem('spmObj') || '{}');
    if (JSON.stringify(storageSpmObj) === '{}') {
      // 全局监听页面路径变化
      // 获取sessionStorage.pathArr
      const storagePathArr = JSON.parse(sessionStorage.getItem('pathArr') || '[]');
      const pathArr = storagePathArr || [];
      const { pathname } = this.props.location || {};
      if (pathname !== '/') {
        pathArr.push(pathname);
        // 补充 sessionStorage.storagePathArr 数据
        sessionStorage.setItem('pathArr', JSON.stringify(pathArr));
        // zzd埋点 暂时先不开放
        us_aplus_queue({
          page_id: pathname,
          page_name: pathname,
          page_url: pathname,
        });
      }
    }

    return (
      <Switch>
        {getRoutes(match.path, routerData)?.map(item => (
          <AuthorizedRoute {...item} key={item.path} redirectPath="/exception/403" />
        ))}
        <Redirect from="/" exact to="/claim/control-platform" />
        <Route render={props => <NotFound {...props} />} />
      </Switch>
    );
  }
}

export default ZcyBaseLayout;
